/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {getSupportDetails} from '@ion/dls/src/theme/resellers/Resellers';

/**
 * Generic function to Launches a separate tab to display page.
 */
const launch = (entry: string) => () => {
  window.open(getSupportDetails()?.[entry], '_blank');
};

/**
 * Launches a separate tab to display the CalAmp linkedIn page.
 */
export const openLinkedIn = launch('linkedIn');

/**
 * Launches a separate tab to display the CalAmp facebook page.
 */
export const openFacebook = launch('facebook');
/**
 * Launches a separate tab to display the CalAmp twitter page.
 */
export const openTwitter = launch('twitter');

/**
 * Launches a separate tab to display the CalAmp youtube page.
 */
export const openYoutube = launch('youtube');
